const DEFAULT_CTA_URL = "https://www.risingpixel.com/";
const APPROVED_CTA_HOSTS = new Set(["risingpixel.com", "www.risingpixel.com"]);

/**
 * The CTA destination is configurable per campaign, but only within an
 * allowlist — an env var must never be able to point the button at an
 * arbitrary host.
 */
export function resolvedCtaUrl(raw = import.meta.env.VITE_CTA_URL as string | undefined): string {
  try {
    const url = new URL(raw || DEFAULT_CTA_URL);
    return url.protocol === "https:" && APPROVED_CTA_HOSTS.has(url.hostname.toLowerCase())
      ? url.toString()
      : DEFAULT_CTA_URL;
  } catch {
    return DEFAULT_CTA_URL;
  }
}
